export const initialValues = {
  title: '',
  defaultIndex: '',
  style: 'default',
  lineStyle: 'linear',
  provider: 'typesense',
  // Sidebar filters render as collapsible <details> sections when true, else as
  // plain always-open blocks (the default).
  collapsibleFilters: false,
  // Footer stamped on downloaded chart images (PNG/SVG only — CSV has none).
  // Chart-wide: every group's download gets the same footer, since one chart
  // reads one collection and so has one source. The page URL and date are
  // filled in automatically at download time; these two are configurable.
  // Whether the Download control appears at all is per-group (group.toolbar).
  imageFooter: {
    source: 'NVIDIA',
    disclaimer: 'Measured performance at date of benchmark, subject to change. '
      + 'Actual results may vary by workload and system configuration.',
  },
  groups: [],
};

export const groupDefaults = {
  label: '',
  labelFields: '',
  description: '',
  type: 'line',
  groupByFields: '',
  groupLabelFormat: '',
  filterBy: '',
  axes: {
    x: {
      label: '',
      field: '',
      band: {
        mode: '',
        fields: ['', ''],
        label: '',
        // Gate: offer the band option only while the current rows carry this
        // field. Empty = always offered. Spelled out here so the key is visible
        // in every saved config rather than existing only in hand-edited JSON.
        showWhenField: '',
      },
    },
    y: {
      label: '',
      field: '',
    },
    // Extra selectable Y metrics beyond axes.y ([{ label, field }, ...]). The
    // switcher lists axes.y first (the default), then these; shown only when the
    // total is >1. Do not repeat axes.y here — yAxesOf merges them.
    yOptions: [],
  },
  tooltip: {
    title: '',
    text: '',
  },
  // Toolbar controls are opt-in per chart (off by default) so enabling them on
  // one chart doesn't add controls to every existing chart.
  toolbar: {
    viewToggle: false,
    download: false,
    share: false,
  },
  // Pareto frontier (opt-in). `frontierOnly` draws only each curve's
  // non-dominated points as the connected line; `showDominated` then adds the
  // off-frontier points back as hollow markers. showDominated depends on
  // frontierOnly — with it off every point is already drawn, so there is no
  // "dominated" set to distinguish. Off by default: non-Pareto charts keep the
  // connect-all-points line.
  pareto: {
    frontierOnly: false,
    showDominated: false,
  },
  filters: [],
  colorsMap: [],
}

export const filterSourceDefaults = {
  label: '',
  attribute: '',
  kind: 'checkboxes',
  defaultValues: [],  // Array of default facet values to pre-select
};

export const lineColor = {
  id: '',
  color: '',
  lineStyle: 'solid',
  markerShape: 'circle',
  markerFill: 'filled',
};


export const colorPalette = {
  "brandGreen": "#76b900",

  // Sub Color Palette (ordered by number, highest to lowest)
  "green700": "#265600",
  "green500": "#337a00",
  "green300Brand": "#76b900",
  "green100": "#b2e639",
  "blue800": "#002781",
  "blue700": "#0046a4",
  "blue500": "#0074df",
  "blue200": "#7cd7fe",
  "fuschia800": "#5d1337",
  "fuschia700": "#8c1c55",
  "fuschia500": "#d2308e",
  "fuschia300": "#fc79ca",
  "fuschia100": "#ffd3f2",
  "purple800": "#4d1368",
  "purple700": "#741d9d",
  "purple400": "#c359ef",
  "purple100": "#f9d4ff",
  "red700": "#961515",
  "red500": "#e52020",
  "red300": "#ff8181",
  "red100": "#ffd7d7",
  "teal700": "#04554b",
  "teal500": "#0d8473",
  "teal300": "#1dbba4",
  "teal100": "#9aefe5",
  "yellow400": "#df6500",
  "yellow300": "#ef9100",
  "yellow200": "#f9c500",
  "yellow100": "#fcde7b",
}
